/*
 *
 * PluginLoader actions
 *
 */

import * as constants from './constants';

export function setPluginSchema(pluginId, schema) {
  return {
    type: constants.SET_PLUGIN_SCHEMA,
    pluginId,
    schema,
  };
}

export function getPluginSchema(pluginId, version, schemaCallback) {
  return {
    type: constants.GET_PLUGIN_SCHEMA,
    pluginId,
    version,
    schemaCallback,
  };
}
